import * as React from "react";
import Card from "@mui/material/Card";
import { CardMedia, useMediaQuery } from '@mui/material';
import BANNER_IMAGE from "../../../../assets/mobileBanner.jpg";
import DESKTOP_BANNER_IMAGE from "../../../../assets/desktopBanner.jpg";

import { styled } from "@mui/system";

const StyledCard = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    height: 200, // Height for small screens
  },
  [theme.breakpoints.between("sm", "md")]: {
    height: 350, // Height for medium screens
  },
  [theme.breakpoints.up("md")]: {
    height: 250, // Height for large screens
  },
}));

export default function ActionAreaCard() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <StyledCard
      elevation={1}
      sx={{
        boxShadow: 7,
      }}
    >
      <CardMedia
        component="img"
        image={isMobile ? BANNER_IMAGE : DESKTOP_BANNER_IMAGE}
        sx={{
          objectFit: 'cover',
          width: '100%', 
          height: '100%', 
        }}
      />
    </StyledCard>
  );
}
